import { useCallback } from 'react';
import { toast } from 'sonner';
import { useAuth } from '@/auth/AuthProvider';
import { ImpersonationService } from '@/services/users/ImpersonationService';

export const useImpersonate = () => {
  const { user: authUser } = useAuth();

  const impersonate = useCallback(
    (targetUserId: string, targetLabel: string, redirectTo?: string) => {
      if (!authUser?.id) return;

      const currentImpersonatedUserId = ImpersonationService.getImpersonatedUserId();
      if (currentImpersonatedUserId === targetUserId) {
        toast.info(`Already impersonating ${targetLabel}`);
        return;
      }

      toast.info(`Switching impersonation to ${targetLabel}...`);
      const adminUserId = ImpersonationService.getAdminUserId() || authUser.id;
      ImpersonationService.startImpersonation(adminUserId, targetUserId, redirectTo);
    },
    [authUser?.id],
  );

  return { impersonate };
};
